import { bigQuery } from '@fiverr-private/obs';
import { sendMixpanel } from '../../utils/events/mixpanel';
import { GrafanaEvents } from '../../utils/events/grafana';
import { BigQueryEvents } from '../../utils/events/bigQuery';
import { MixpanelEvents } from '../../utils/events/mixpanel/events';
import { metric } from '../../../lib/metric';

export const ReportingChannelType = {
    GRAFANA: {
        name: 'grafana',
        events: GrafanaEvents,
        reporter: metric.count,
    },
    BIG_QUERY: {
        name: 'bigQuery',
        events: BigQueryEvents,
        reporter: bigQuery.send,
    },
    MIXPANEL: {
        name: 'mixpanel',
        events: MixpanelEvents,
        reporter: sendMixpanel,
    },
};
